var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAppleLogo = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 18,
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12.4639 0C12.5058 0 12.5477 0 12.592 0C12.6947 1.2694 12.2102 2.21789 11.6213 2.90476C11.0435 3.58688 10.2523 4.24845 8.97267 4.14807C8.88731 2.89685 9.37262 2.01871 9.96068 1.33342C10.5061 0.69477 11.5059 0.126466 12.4639 0Z",
  fill: "white"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.3378 13.2128C16.3378 13.2254 16.3378 13.2365 16.3378 13.2483C15.9782 14.3375 15.4652 15.271 14.8392 16.1373C14.2677 16.9237 13.5674 17.9821 12.317 17.9821C11.2365 17.9821 10.5188 17.2873 9.41147 17.2684C8.24008 17.2494 7.5959 17.8493 6.5249 18.0003C6.40238 18.0003 6.27987 18.0003 6.15973 18.0003C5.37327 17.8865 4.73857 17.2636 4.27618 16.7024C2.91272 15.0442 1.85911 12.9021 1.66309 10.161C1.66309 9.89226 1.66309 9.62432 1.66309 9.35558C1.74608 7.39378 2.69931 5.79873 3.96634 5.02571C4.63503 4.6147 5.55427 4.26455 6.57785 4.42105C7.01653 4.48902 7.46469 4.6392 7.85753 4.7878C8.22981 4.93086 8.69536 5.18458 9.13641 5.17115C9.43518 5.16245 9.73238 5.00674 10.0335 4.89688C10.9156 4.57834 11.7803 4.21317 12.9201 4.38469C14.2899 4.59178 15.2621 5.20039 15.8628 6.1394C14.7041 6.87685 13.788 7.98817 13.9445 9.88594C14.0836 11.6098 15.0858 12.6184 16.3378 13.2128Z",
  fill: "white"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgAppleLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "770080d97d28b8a5e8813d341cb78a41.svg";